import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import { ToWords } from 'to-words';
import dayjs from 'dayjs';
import TransfertSimple from "./Transfert/TransfertSimple";
import { getTransferInfos } from "./Transfert/Services/transfertService";
import ProjetSelect from "../GestionProjets/ProjetSelect";   // ⚠️ chemin relatif vers le module Gestion de projets


const baseUrl = process.env.REACT_APP_BASE_URL;

// ✅ Sous-composant : une ligne de détail du document
const DocumentDetailRow = ({ index, detail, articleOptions, handleDetailChange, removeDetail }) => (
    <tr key={detail.uniqueId}>
        <td style={{ width: "30%" }}> {/* 🔹 largeur élargie à 20% */}
            <Select
                name="articleId"
                value={articleOptions.find(opt => opt.value === detail.articleId) || null}
                onChange={option =>
                    handleDetailChange(index, { target: { name: "articleId", value: option?.value || "" } })
                }
                options={articleOptions}
                placeholder="-- Sélectionnez --"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                    container: base => ({ ...base, width: "100%" }),
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    menu: base => ({ ...base, width: '100%' })
                }}
            />
        </td>
        <td>
            <input
                type="number"
                name="quantite"
                min="1"
                value={detail.quantite}
                onChange={e => handleDetailChange(index, e)}
                className="form-control"
            />
        </td>
        <td>
            <input
                type="number"
                name="prixUnitaire"
                min="0"
                value={detail.prixUnitaire}
                onChange={e => handleDetailChange(index, e)}
                className="form-control"
            />
        </td>
        <td>
            <input
                type="number"
                name="tva"
                min="0"
                value={detail.tva}
                onChange={e => handleDetailChange(index, e)}
                className="form-control"
            />

        </td>
        <td>
            <input
                type="text"
                name="montantTotalDetail"
                value={detail.montantTotal.toFixed(2)}
                readOnly
                className="form-control bg-light"
            />
        </td>
        <td>
            <button className="btn btn-sm btn-danger" onClick={() => removeDetail(index)}>
                Supprimer
            </button>
        </td>
    </tr>
);

const DocumentAchatEntity = ({ type, title, endpoint }) => {
    const [documentsList, setDocumentsList] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [articles, setArticles] = useState([]);
    const [showExportModal, setShowExportModal] = useState(false);
    const [lignesTransfert, setLignesTransfert] = useState([]);
const [reglementsDoc, setReglementsDoc] = useState(null);   // null = pop-up fermé

const handleShowReglements = async (item) => {
    try {
        const res = await axiosInstance.get(`${baseUrl}/api/PaymentLines/ByDocument/${item.id}`);
        setReglementsDoc({ numero: item.numero, totalTTC: item.totalTTC, liste: res.data?.data ?? res.data ?? [] });
    } catch {
        Swal.fire("Erreur", "Impossible de charger les règlements.", "error");
    }
};const [livraisons, setLivraisons] = useState(null);

    const [form, setForm] = useState({
        id: "",
        numero: "Numéro généré automatiquement, (Ex : FA-XXXXX)",
        etat: "",
        dateDocument: new Date().toISOString().split("T")[0],
        entrepriseId: 0,
        supplierId: 0,
        warehouseId: 0,
        supplierName: "",
        projetId: "",            // projet d'imputation (facultatif)
        validite: 0,
        totalHT: 0,
        totalTVA: 0,
        totalTTC: 0,
        details: [],
        // entrepriseInfo: {}
    });
    const columns = ["numero", "dateDocument", "supplierName", "totalTTC", "statut"];
    if (endpoint === "BonCommandeAchat") { columns.push("deliveryStatusLabel"); }
    if (endpoint === "BonReception" || endpoint === "FactureAchat" || endpoint === "BonCommandeAchat") { columns.push("paymentStatusLabel"); }
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [loading, setLoading] = useState(true);

    const articleOptions = articles.map(a => ({
        value: a.id,
        label: `${a.codeBar || a.code || ""} (${a.nameLat})`
    }));

    const supplierOptions = suppliers.map(s => ({
        value: s.id,
        label: s.name
    }));

    useEffect(() => {
        fetchDocuments();
        fetchDependencies();
    }, []);

    const fetchDependencies = async () => {
    const [suppliersRes, articlesRes, warehousesRes] = await Promise.allSettled([
        axiosInstance.get(`${baseUrl}/api/Suppliers`),
        axiosInstance.get(`${baseUrl}/api/Articles`),
        axiosInstance.get(`${baseUrl}/api/Depots/warehouses`),
    ]);

    if (suppliersRes.status === "fulfilled") setSuppliers(suppliersRes.value.data);
    else console.error("Erreur Suppliers :", suppliersRes.reason?.response?.data || suppliersRes.reason);

    if (articlesRes.status === "fulfilled") setArticles(articlesRes.value.data);
    else console.error("Erreur Articles :", articlesRes.reason?.response?.data || articlesRes.reason);

    // if (warehousesRes.status === "fulfilled") setWarehouses(warehousesRes.value.data);
    // else console.error("Erreur Warehouses :", warehousesRes.reason?.response?.data || warehousesRes.reason);
  if (warehousesRes.status === "fulfilled") {
    const data = warehousesRes.value.data;

    console.log("Réponse API dépôts :", data);
    console.log("Type de data :", typeof data);
    console.log("Tableau :", Array.isArray(data));

    const list = Array.isArray(data)
        ? data
        : Array.isArray(data?.value)
            ? data.value
            : Array.isArray(data?.$values)
                ? data.$values
                : [];

    setWarehouses(list);
} else {
    console.error("Erreur API dépôts :", warehousesRes.reason);
    setWarehouses([]);
}
};

    function convertToInputDateFormat(dateStr) {
        // Attend une date au format dd/MM/yyyy
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    const fetchDocuments = () => {
        axiosInstance.get(`${baseUrl}/api/${endpoint}`).then((res) => {
            console.log("Voici la response : ", res)
            const formattedData = res.data.map(item => ({
                ...item,
                dateDocument: dayjs(item.dateDocument).format('DD/MM/YYYY')
            }));
            console.log("Voici la response : ", formattedData)

            setDocumentsList(formattedData);
        }).catch(() => console.log("Impossible de charger les documents"))
            .finally(() => setLoading(false));
    };
    const handleChange = e => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    // ✅ gestion d’un champ de détail
    const handleDetailChange = (index, e) => {
        debugger
        const { name, value } = e.target;
        setForm(prev => {
            const details = [...prev.details];
            const current = { ...details[index] };

            if (name === "articleId") {
                const selected = articles.find(a => a.id === Number(value));
                current.articleId = Number(value);
                current.code = selected?.code;
                current.articleName = selected?.nameLat || "";
                current.prixUnitaire = selected?.purchasePrice || 0;
                current.tva = selected?.tva || 0;
            } else {
                current[name] = Number(value);
            }

            current.montantTotal = current.quantite * current.prixUnitaire;
            details[index] = current;
            console.log("current", current)

            const totalHT = details.reduce((sum, d) => sum + d.montantTotal, 0);

            // Calcul du total TVA (ex : 20%)
            const totalTVA = details.reduce((sum, d) => sum + (d.montantTotal * (d.tva || 0) / 100), 0);

            // Calcul du total TTC
            const totalTTC = totalHT + totalTVA;
            return { ...prev, details, totalHT, totalTVA, totalTTC };
        });
    };

    // ✅ ajouter une ligne de détail unique
    const addDetail = () => {
        setForm(prev => ({
            ...prev,
            details: [
                ...prev.details,
                {
                    uniqueId: uuidv4(),
                    id: 0,
                    articleId: 0,
                    articleName: "",
                    code: "",
                    quantite: 1,
                    prixUnitaire: 0,
                    tva: 0,
                    montantTotal: 0
                }
            ]
        }));
    };

    // ✅ supprimer une ligne
    const removeDetail = index => {
        debugger
        setForm(prev => {
            const details = prev.details.filter((_, i) => i !== index);
            const totalHT = details.reduce((sum, d) => sum + d.montantTotal, 0);
            // Calcul du total TVA (ex : 20%)
            const totalTVA = details.reduce((sum, d) => sum + (d.montantTotal * (d.tva || 0) / 100), 0);

            // Calcul du total TTC
            const totalTTC = totalHT + totalTVA;

            return { ...prev, details, totalHT, totalTVA, totalTTC };
        });
        console.log(form);
    };

    const resetForm = () => {
        // const numericNumbers = documentsList
        //     .map(d => Number(d.numero))
        //     .filter(n => !isNaN(n));
        // // const nextNumero =
        // //     numericNumbers.length > 0 ? Math.max(...numericNumbers) + 1 : 1;

        // const nextNumero =
        //     numericNumbers.length > 0
        //         ? (Math.max(...numericNumbers) + 1).toString().padStart(5, "0")
        //         : "00001";


        setForm({
            id: "",
            numero: "Numéro généré automatiquement, (Ex : FA-XXXXX)",
            etat: "",
            dateDocument: new Date().toISOString().split("T")[0],
            entrepriseId: 0,
            supplierId: 0,
            warehouseId: 0,
            supplierName: "",
            projetId: "",
            validite: 0,
            totalHT: 0,
            totalTVA: 0,
            totalTTC: 0,
            details: [],
            // entrepriseInfo: {}
        });
        setSelectedDocument(null);
    };

    const handleSubmit = () => {
        if (!form.supplierId || form.details.length === 0) {
            Swal.fire("Erreur", "Veuillez remplir tous les champs obligatoires.", "warning");
            return;
        }

        const url = selectedDocument
            ? `${baseUrl}/api/${endpoint}/UpdateDocument`
            : `${baseUrl}/api/${endpoint}/CreateDocument`;

        // 🧹 Nettoyage des détails avant envoi (on enlève uniqueId)
        // const cleanedDetails = form.details.map(d => ({
        //     id: d.id || 0,
        //     articleId: d.articleId,
        //     code: d.code,
        //     quantite: d.quantite,
        //     articleName: d.articleName,
        //     prixUnitaire: d.prixUnitaire,
        //     tva: d.tva,
        //     montantTotal: d.montantTotal
        // }));
        // 🧾 Nouveau form à envoyer au backend
        // const payload = {
        //     ...form,
        //     supplierId: parseInt(form.supplierId, 10), // conversion string → number
        //     warehouseId: parseInt(form.warehouseId, 10), // conversion string → number
        //     validite: parseInt(form.validite, 10), // conversion string → number
        //     details: cleanedDetails
        // };

        const payload = {
            id: form.id,
            numero: form.numero || "",
            dateDocument: form.dateDocument || "",
            entrepriseId: form.entrepriseId,
            supplierId: Number(form.supplierId) || 0,
            projetId: form.projetId || null,      // null = opération courante (hors projet)
            warehouseId:  form.warehouseId|| 1,
            validite: form.validite || 1,
            etat: form.etat || "EnCours",
            totalHT: form.totalHT,
            totalTVA: form.totalTVA,
            totalTTC: form.totalTTC,
            details: form.details.map(d => ({
                id: d.id,
                articleId: d.articleId,
                code: d.code || "code",
                articleName: d.articleName || "pop",
                quantite: d.quantite,
                quantiteRestante: d.quantiteRestante || 0,
                transferredQuantity: d.transferredQuantity || 0,
                prixUnitaire: d.prixUnitaire,
                tva: d.tva,
                montantTotal: d.montantTotal
            }))
        };
        console.log('payload', payload)

        axiosInstance
            .post(url, payload)
            .then(() => {
                window.$("#modalForm").modal("hide");
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès !",
                    showConfirmButton: false,
                    timer: 2000
                });
                fetchDocuments();
                resetForm();
            })
            .catch(() => {
                Swal.fire("Erreur", "Opération échouée !", "error");
            });
    };


    const toWords = new ToWords({
        localeCode: 'fr-FR',
        converterOptions: {
            currency: true,
            currencyOptions: {
                name: 'dirham',
                plural: 'dirhams',
                fractionalUnit: {
                    name: 'centime',
                    plural: 'centimes',
                },
            },
        },
    });
    function montantEnLettres(montant) {
        // Tu peux intégrer une vraie fonction plus tard
        return toWords.convert(montant);
    }
    const exportDocumentsPdf = (item, print = false) => {
        const doc = new jsPDF();
        const currentYear = new Date().getFullYear();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        // === Logo de l'entreprise ===
        const logoPath = `${process.env.PUBLIC_URL}/dist/img/logo_ecogen.PNG`;
        const logoWidth = 120;
        const logoHeight = 40;
        doc.addImage(logoPath, "PNG", 13, 0, logoWidth, logoHeight);

        // === Ligne de séparation ===
        doc.setDrawColor(150);
        doc.line(14, 35, 195, 35); // ligne horizontale

        // === Titre du document à droite ===
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);//`${baseUrl}/api/${endpoint}/UpdateDocument`
        doc.text(`${type} N° ${item.numero || ""}/${currentYear || ""}`, 80, 45);



        // === Informations principales ===
        const userName = localStorage.getItem("username");
        var emailSupplier = suppliers.find(a => a.id === item.supplierId)?.email
        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(`Date : ${new Date(item.dateDocument).toLocaleDateString()}`, 14, 65);
        doc.text(`Fournisseur : ${item.supplierName || ""}`, 14, 75);
        doc.text(`Email : ${emailSupplier || ""}`, 14, 85);
        doc.text(`Crée par : ${userName || ""}`, 120, 65);

        // === Tableau des articles ===
        const columns = ["Code", "Désignation", "Quantité", "Prix U.", "TVA", "Total"];
        const rows = (item.details || []).map(d => [
            articles.find(a => a.id === d.articleId)?.code || "",
            articles.find(a => a.id === d.articleId)?.nameLat || "",
            d.quantite,
            d.prixUnitaire,
            d.tva,
            d.montantTotal.toFixed(2)
        ]);

        autoTable(doc, {
            startY: 95,
            head: [columns],
            body: rows,
            styles: { fontSize: 10, cellPadding: 2 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 }, // bleu pro
            alternateRowStyles: { fillColor: [245, 245, 245] },
        });

        // === Calculs ===
        const finalY = doc.lastAutoTable.finalY || 70;
        const totalHT = item.totalHT || 0;
        const totalTVA = item.totalTVA;
        const totalTTC = item.totalTTC;

        // === Tableau récapitulatif ===
        // doc.setFontSize(12);
        // doc.text(`Total HT : ${totalHT.toFixed(2)} Dh`, 140, finalY + 10);
        // doc.text(`Total TVA : ${totalTVA.toFixed(2)} Dh`, 140, finalY + 16);
        // doc.text(`Total TTC : ${totalTTC.toFixed(2)} Dh`, 140, finalY + 22);

        // === Tableau récapitulatif ===
        const columnsRecap = ["Total H.T", "T.V.A", "Total T.T.C"];
        const rowsRecap = [
            [
                `${totalHT.toFixed(2)} Dh`,
                `${totalTVA.toFixed(2)} Dh`,
                `${totalTTC.toFixed(2)} Dh`
            ]
        ];

        // ✅ Tableau récap plus petit et aligné à droite
        autoTable(doc, {
            startY: finalY + 10,
            head: [columnsRecap],
            body: rowsRecap,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 2 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
            tableWidth: 70, // largeur réduite
            margin: { left: doc.internal.pageSize.width - 70 - 14 }, // décalé à droite
        });

        // === Section "Arrêtée..." centrée en bas de page ===
        const baseY = pageHeight - 50; // à ~50 px du bas
        const recapFinalY = doc.lastAutoTable.finalY || finalY + 10; // position du bas du tableau récap
        const spaceAfterRecap = 12; // espace modéré (en px)
        doc.setFontSize(11);
        doc.text("Arrêtée, la présente facture à la somme de :", pageWidth / 2, recapFinalY + spaceAfterRecap, { align: "center" });
        doc.text(montantEnLettres(totalTTC), pageWidth / 2, recapFinalY + spaceAfterRecap + 7, { align: "center" });
        doc.text("Signé par", pageWidth / 2, recapFinalY + spaceAfterRecap + 20, { align: "center" });

        // === Infos entreprise centrées en bas ===
        const infos = [
            `Siège social : ${item.entrepriseInfo.adresse || ""}`,
            `Email : ${item.entrepriseInfo.email || ""}`,
            `Patente : ${item.entrepriseInfo.patente || ""}    CNSS : ${item.entrepriseInfo.cnss || ""}    RC : ${item.entrepriseInfo.rc || ""}    IF : ${item.entrepriseInfo.ifEntreprise || ""}`,
            `Banque : ${item.entrepriseInfo.rib || ""}    ICE : ${item.entrepriseInfo.ice || ""}`
        ];
        const footerMarginBottom = 15; // marge basse
        const footerLineHeight = 5;
        const footerHeight = infos.length * footerLineHeight;

        // Y de départ pour le footer
        let footerY = pageHeight - footerHeight - footerMarginBottom;
        doc.setDrawColor(180);
        doc.line(14, footerY - 8, pageWidth - 14, footerY - 8);

        doc.setFontSize(9);

        // point de départ juste après la section "Signé par"
        let y = recapFinalY + spaceAfterRecap + 35; // 35px après la ligne "Signé par"

        doc.setFont("helvetica", "bold");
        doc.setFontSize(9); // texte un peu plus petit

        infos.forEach(line => {
            doc.text(line, pageWidth / 2, footerY, { align: "center" });
            footerY += 5;
        });

        // === Sauvegarde ===
        // doc.save(`${type}_${item.numero || "export"}.pdf`);

        const fileName = `${type}_${item.numero || "export"}.pdf`;

        if (print) {

            // Ouvrir le PDF dans un nouvel onglet
            const pdfBlob = doc.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);

            const win = window.open(pdfUrl);

            if (win) {

                win.onload = () => {

                    win.focus();
                    win.print();

                };

            }

        }
        else {

            doc.save(fileName);

        }
    };

    const handleEdit = item => {
        const formattedDocument = {
            ...item,
            projetId: item.projetId ?? "",
            dateDocument: convertToInputDateFormat(item.dateDocument),
            details: item.details.map(d => ({
                uniqueId: uuidv4(),
                id: d.id,
                articleId: d.articleId,
                code: "",
                articleName: "",
                quantite: d.quantite,
                quantiteRestante: d.quantiteRestante,
                transferredQuantity: d.transferredQuantity,
                prixUnitaire: d.prixUnitaire,
                tva: d.tva,
                montantTotal: d.montantTotal
            }))
        };
        console.log("formattedDocument",formattedDocument)
        setSelectedDocument(formattedDocument);
        setForm(formattedDocument);
        setTimeout(() => window.$("#modalForm").modal("show"), 100);
    };
const handleShowLivraisons = async (item) => {
    try {
        const mode = endpoint === "BonCommandeAchat" ? "achat" : "vente";
        const targetType = endpoint === "BonCommandeAchat" ? "BonReception" : "BonLivraison";
       console.log(mode,':',targetType)
        const res = await axiosInstance.get(
            `${baseUrl}/api/Transfer/DocumentsCrees/${item.id}`,   // ⚠️ route de ton contrôleur de transfert
            { params: { targetType } }
        );
        const liste = res.data?.data ?? res.data ?? [];

        // Récap par article : commandé / livré / reste
        const livre = {};
        liste.forEach(d => d.lignes.forEach(l => {
            livre[l.articleId] = (livre[l.articleId] || 0) + Number(l.quantite);
        }));
        const recap = (item.details || []).map(d => ({
            article: articles.find(a => a.id === d.articleId)?.nameLat || d.articleId,
            commande: Number(d.quantite),
            livre: livre[d.articleId] || 0,
        }));

        setLivraisons({ numero: item.numero, mode, liste, recap });
    } catch {
        Swal.fire("Erreur", "Impossible de charger les livraisons.", "error");
    }
};
    const handleExport = async item => {
        try {
            // Document exportable uniquement s'il est validé OU payé
            const isBonCommande = endpoint === "BonCommandeAchat";
            const isValidated = item.statut === "Validé";
            const isPaid = item.paymentStatusLabel === "Payé";

            if (!isValidated && !isPaid && isBonCommande) {
                Swal.fire(
                    "Transfert impossible",
                    "Le document doit être validé ou entièrement payé avant de pouvoir être transféré.",
                    "warning"
                );
                return;
            }
            const ligneIds = item.details.map(d => d.id);
            const transferInfos = await getTransferInfos(
                ligneIds,
                endpoint,        // le type source, ex. "BonCommandeAchat"
        item.id 
            );

            const lignes = item.details.map(d => {
                const info = transferInfos.find(
                    x => x.ligneId === d.id
                );

                return {
                    ...d,
                    ligneId: d.id,
                    uniqueId: uuidv4(),
                    stockQuantity: info?.stockQuantity ?? 0,
                    transferredQuantity: info?.transferredQuantity ?? 0,
                    remainingQuantity:
                        info?.remainingQuantity ?? d.quantite
                };
            });

            setLignesTransfert(lignes);

            // IMPORTANT : conserver le document dans form
            setForm(item);
console.log(item)
            setSelectedDocument(item);

            setShowExportModal(true);

        } catch (error) {
            console.error(
                "Erreur récupération informations transfert :",
                error
            );

            Swal.fire(
                "Erreur",
                "Impossible de récupérer les informations de transfert.",
                "error"
            );
        }
    };
    const handleExportSubmit = (data) => {
        console.log("Données reçues du modal :", data);

        // Exemple :
        // appel API
        // setState
        // traitement métier

        setShowExportModal(false); // fermer le modal
    };
    const handleExportPdf = item => {
        const formattedDocument = {
            ...item,
            dateDocument: convertToInputDateFormat(item.dateDocument),
            details: item.details.map(d => ({
                uniqueId: uuidv4(),
                id: d.id,
                articleId: d.articleId,
                code: "",
                articleName: "",
                quantite: d.quantite,
                prixUnitaire: d.prixUnitaire,
                tva: d.tva,
                montantTotal: d.montantTotal
            }))
        };
        exportDocumentsPdf(formattedDocument);
    };

    const handlePrintPdf = item => {

        const formattedDocument = {

            ...item,

            dateDocument: convertToInputDateFormat(item.dateDocument),

            details: item.details.map(d => ({

                uniqueId: uuidv4(),

                id: d.id,

                articleId: d.articleId,

                code: "",

                articleName: "",

                quantite: d.quantite,

                prixUnitaire: d.prixUnitaire,

                tva: d.tva,

                montantTotal: d.montantTotal

            }))

        };

        exportDocumentsPdf(formattedDocument, true);

    };

    const handleValidate = id => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, valider",
            cancelButtonText: "Annuler"
        }).then(result => {
            if (result.isConfirmed) {
                axiosInstance
                    .post(`${baseUrl}/api/${endpoint}/ValidateDocument`, { idString: id }).then(() => {
                        window.$("#modalForm").modal("hide");
                        Swal.fire({
                            toast: true,
                            position: "top-end",
                            icon: "success",
                            title: "Document validé avec succès !",
                            showConfirmButton: false,
                            timer: 2000
                        });
                        fetchDocuments();
                    })
                    .catch(() => {
                        Swal.fire("Erreur", "Opération échouée !", "error");
                    });
            }
        });
    };

    const handleUnvalidate = id => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, valider",
            cancelButtonText: "Annuler"
        }).then(result => {
            if (result.isConfirmed) {
                axiosInstance
                    .post(`${baseUrl}/api/${endpoint}/UnvalidateDocument`, { idString: id }).then(() => {
                        window.$("#modalForm").modal("hide");
                        Swal.fire({
                            toast: true,
                            position: "top-end",
                            icon: "success",
                            title: "Document dévalidé avec succès !",
                            showConfirmButton: false,
                            timer: 2000
                        });
                        fetchDocuments();
                    })
                    .catch(() => {
                        Swal.fire("Erreur", "Opération échouée !", "error");
                    });
            }
        });
    };

    const handleDelete = id => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then(result => {
            if (result.isConfirmed) {
                axiosInstance
                    .post(`${baseUrl}/api/${endpoint}/DeleteDocument`, { idString: id })
                    .then(() => fetchDocuments());
            }
        });
    };
const estBonCommande = ["BonCommandeAchat", "BonCommandeVente"].includes(endpoint);
console.log("endpoint =", endpoint, "| estBonCommande =", estBonCommande);
console.log("type handleShowLivraisons =", typeof handleShowLivraisons);
    // ===================== Rendu =====================
    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des {`${title}`}</h3>
            <button
                className="btn btn-primary mb-3"
                data-toggle="modal"
                data-target="#modalForm"
                onClick={resetForm}
            >
                <i className="fas fa-plus"></i> Ajouter
            </button>

            {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title={`Liste des ${title}`}
                    columns={columns}
                    columnsMapping={{
                        numero: "Numéro",
                        dateDocument: "Date",
                        supplierName: "Fournisseur",
                        totalTTC: "Montant Total",
                        statut: "Statut",
                        paymentStatusLabel: "Paiement ",
                        deliveryStatusLabel: "Livraison"

                    }}
                    keyField="id"
                    data={documentsList}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleExport={handleExport}
                    handleExportPdf={handleExportPdf}
                    handlePrintPdf={handlePrintPdf}
                    handleValidate={handleValidate}
                    handleUnvalidate={handleUnvalidate}
                    handleShowReglements={handleShowReglements}
                    handleShowLivraisons={estBonCommande ? handleShowLivraisons : undefined}
                />
            )}

            {/* --------- Modal --------- */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedDocument ? "Modifier" : "Ajouter"} un {`${type}`}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="form-group">
                                <label>Numéro</label>
                                <input
                                    type="text"
                                    name="numero"
                                    value={form.numero}
                                    readOnly
                                    className="form-control bg-light"
                                />
                            </div>

                            <div className="form-group">
                                <label>Date</label>
                                <input
                                    type="date"
                                    name="dateDocument"
                                    value={form.dateDocument}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Fournisseur</label>

                                <Select
                                    name="supplierId"
                                    options={supplierOptions}
                                    value={
                                        supplierOptions.find(
                                            option => option.value === form.supplierId
                                        ) || null
                                    }

                                    onChange={(selectedOption) =>
                                        setForm(prev => ({
                                            ...prev,
                                            supplierId: selectedOption ? selectedOption.value : ""
                                        }))
                                    }
                                    placeholder="-- Sélectionnez un fournisseur --"
                                    isClearable
                                    isSearchable
                                />
                            </div>
                            <div className="form-group">
                                <label>Dépo</label>
                                <select
                                    name="warehouseId"
                                    value={form.warehouseId}
                                    onChange={handleChange}
                                    className="form-control"
                                >
                                    <option value="">-- Sélectionnez --</option>
                                    {(Array.isArray(warehouses) ? warehouses : []).map(c => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <ProjetSelect
                                    value={form.projetId}
                                    onChange={(v) => setForm(prev => ({ ...prev, projetId: v }))}
                                />
                                <small className="form-text text-muted">
                                    Laissez vide pour une opération courante. Une facture d'achat imputée compte dans les charges du projet.
                                </small>
                            </div>
                            <div className="form-group">
                                <label>Validité (jours)</label>
                                <input
                                    type="number"
                                    name="validite"
                                    value={form.validite}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <hr />
                            <h6>Détails du {`${type}`}</h6>
                            <button className="btn btn-sm btn-success mb-2" onClick={addDetail}>
                                Ajouter un article
                            </button>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Article</th>
                                        <th>Quantité</th>
                                        <th>Prix U.</th>
                                        <th>TVA</th>
                                        <th>Total</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {form.details.map((d, i) => (
                                        <DocumentDetailRow
                                            key={d.uniqueId}
                                            index={i}
                                            detail={d}
                                            articleOptions={articleOptions}
                                            handleDetailChange={handleDetailChange}
                                            removeDetail={removeDetail}
                                        />
                                    ))}
                                </tbody>
                            </table>

                            <div className="text-right font-weight-bold">
                                Total général : {form.totalTTC.toFixed(2)} Dh
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal">
                                Annuler
                            </button>
                            {selectedDocument && selectedDocument.id && (
                                <button className="btn btn-outline-danger" onClick={() => exportDocumentsPdf(selectedDocument)}>
                                    <i className="fas fa-file-pdf"></i> Exporter PDF
                                </button>
                            )}
                            <button className="btn btn-enregistrer" onClick={handleSubmit}>
                                Sauvegarder
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {reglementsDoc && (() => {
    const totalRegle = reglementsDoc.liste.reduce((t, r) => t + Number(r.montantAffecte || 0), 0);
    const reste = Number(reglementsDoc.totalTTC || 0) - totalRegle;
    return (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Règlements du document {reglementsDoc.numero}</h5>
                        <button className="close" onClick={() => setReglementsDoc(null)}>×</button>
                    </div>
                    <div className="modal-body">
                        {reglementsDoc.liste.length === 0 ? (
                            <p className="text-muted text-center">Aucun règlement affecté.</p>
                        ) : (
                            <table className="table table-sm table-bordered">
                                <thead><tr><th>Référence</th><th>Date</th><th>Mode</th><th className="text-right">Montant affecté</th></tr></thead>
                                <tbody>
                                    {reglementsDoc.liste.map(r => (
                                        <tr key={r.id}>
                                            <td>{r.reference}</td>
                                            <td>{dayjs(r.datePayment).format("DD/MM/YYYY")}</td>
                                            <td>{r.mode}</td>
                                            <td className="text-right">{Number(r.montantAffecte).toFixed(2)} MAD</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        <div className="d-flex justify-content-between font-weight-bold">
                            <span>Total TTC : {Number(reglementsDoc.totalTTC || 0).toFixed(2)} MAD</span>
                            <span className="text-success">Réglé : {totalRegle.toFixed(2)} MAD</span>
                            <span className={reste > 0.001 ? "text-danger" : "text-success"}>Reste : {reste.toFixed(2)} MAD</span>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setReglementsDoc(null)}>Fermer</button>
                    </div>
                </div>
            </div>
        </div>
    );
})()}
      {livraisons && (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.4)" }}>
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h5>{livraisons.mode === "achat" ? "Réceptions" : "Livraisons"} du bon de commande {livraisons.numero}</h5>
                    <button className="close" onClick={() => setLivraisons(null)}>×</button>
                </div>
                <div className="modal-body">
                    <h6>Récapitulatif</h6>
                    <table className="table table-sm table-bordered">
                        <thead><tr><th>Article</th><th>Commandé</th><th>{livraisons.mode === "achat" ? "Reçu" : "Livré"}</th><th>Reste</th></tr></thead>
                        <tbody>
                            {livraisons.recap.map((r, i) => (
                                <tr key={i} className={r.livre >= r.commande ? "table-success" : r.livre > 0 ? "table-warning" : ""}>
                                    <td>{r.article}</td><td>{r.commande}</td><td>{r.livre}</td><td>{Math.max(0, r.commande - r.livre)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <h6 className="mt-3">Détail par document</h6>
                    {livraisons.liste.length === 0 && <p className="text-muted">Aucun document.</p>}
                    {livraisons.liste.map(d => (
                        <div key={d.id} className="mb-2">
                            <strong>{d.numero}</strong> <small className="text-muted">{dayjs(d.dateDocument).format("DD/MM/YYYY")} — {d.statut}</small>
                            <table className="table table-sm table-bordered mt-1 mb-0">
                                <tbody>
                                    {d.lignes.map((l, i) => <tr key={i}><td>{l.articleName}</td><td style={{ width: 120 }}>{l.quantite}</td></tr>)}
                                </tbody>
                            </table>
                        </div>
                    ))}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setLivraisons(null)}>Fermer</button>
                </div>
            </div>
        </div>
    </div>
)}  
            {showExportModal && (
                <TransfertSimple
                    title="Détail document"
                    products={lignesTransfert}
                    onSubmit={handleExportSubmit}
                    onClose={() => setShowExportModal(false)}
                    mode="achat"
                    docType={endpoint}
                    docId={form.id}
                    tierId={form.clientId}
                />
            )}
        </div>
    );
};

export default DocumentAchatEntity;